'use strict';

var _ = require('lodash');
var GridSendFlightReoptButtonController = function GridSendFlightReoptButtonController($scope, scenarioService, reoptimizationService) {
  var gridPanel = $scope.gridPanelScope;
  var flightManagementGrids = ['inventory-management', 'overbooking-management'];
  $scope.flightSendPermissions = {
    'reopt': 'write',
    'flight-optimization': 'write'
  };
  $scope.selectedRows = [];
  $scope.onRowSelection = function (event, selectedRows) {
    var isScenarioSelected = scenarioService.isScenarioSelected();
    $scope.selectedRows = setSelectedRowsOnFlightManagement(selectedRows);
    $scope.hasRows = $scope.selectedRows.length > 0;
    if (gridPanel.reoptPreviewData.ndReopt) {
      $scope.isReoptimizeButtonShown = !isScenarioSelected && ($scope.hasRows || !gridPanel.reoptPreviewData.ndReopt.read);
    } else {
      $scope.isReoptimizeButtonShown = $scope.hasRows && !isScenarioSelected;
    }
    $scope.selectedRows = setSelectedRowsOnFlightManagement(selectedRows);
  };
  function setSelectedRowsOnFlightManagement(selectedRows) {
    if (flightManagementGrids.indexOf(gridPanel.gridId) > -1) {
      return _.size(selectedRows) > 0 ? selectedRows : _.get(gridPanel, 'jqxGridSettings.source.loadedData', []);
    }
    return selectedRows;
  }
  $scope.sendOptimization = function () {
    if (gridPanel.reoptPreviewData.ndReopt && !gridPanel.reoptPreviewData.ndReopt.success) {
      return;
    }
    return reoptimizationService.reoptimizeNDFromFlightScreen($scope.selectedRows, undefined, 'Y', false);
  };
  $scope.isButtonShown = function () {
    return $scope.isReoptimizeButtonShown || isFlightManagementGrid();
  };
  function isFlightManagementGrid() {
    return flightManagementGrids.indexOf(gridPanel.gridId) > -1;
  }
  $scope.$watch('gridPanelScope.gridDataLoaded', function () {
    if (gridPanel.jqxGridSettings.source && isFlightManagementGrid()) {
      $scope.onRowSelection();
    }
  });
};
GridSendFlightReoptButtonController.$inject = ['$scope', 'ScenarioService', 'ReoptimizationService'];
module.exports = GridSendFlightReoptButtonController;